import {WorkflowType} from "../../utils/enums";
import {WorkflowOption} from "./types";

export const WORKFLOW_OPTIONS: Record<WorkflowType, WorkflowOption> = {
  [WorkflowType.ADMISSION]: {
    type: WorkflowType.ADMISSION,
    label: "Admission",
  },
  [WorkflowType.ARBITRATION]: {
    type: WorkflowType.ARBITRATION,
    label: "Arbitration",
  },
  [WorkflowType.ADMISSION_SPANISH]: {
    type: WorkflowType.ADMISSION_SPANISH,
    label: "Admission (Spanish)",
  },
  [WorkflowType.READMISSION]: {
    type: WorkflowType.READMISSION,
    label: "Readmission",
  },
  [WorkflowType.READMISSION_SPANISH]: {
    type: WorkflowType.READMISSION_SPANISH,
    label: "Readmission (Spanish)",
  },
  [WorkflowType.PENDING]: {
    type: WorkflowType.PENDING,
    label: "Pending workflow",
  },
  [WorkflowType.FINANCIAL_PACKET]: {
    type: WorkflowType.FINANCIAL_PACKET,
    label: "Financial Packet",
  },
  [WorkflowType.FINANCIAL_PACKET_SPANISH]: {
    type: WorkflowType.FINANCIAL_PACKET_SPANISH,
    label: "Financial Packet (Spanish)",
  },
  [WorkflowType.ADMISSION_CONSERVATOR]: {
    type: WorkflowType.ADMISSION_CONSERVATOR,
    label: "Admission Conservator",
  },
  [WorkflowType.ADMISSION_CONSERVATOR_SPANISH]: {
    type: WorkflowType.ADMISSION_CONSERVATOR_SPANISH,
    label: "Admission Conservator (Spanish)",
  },
  [WorkflowType.ARBITRATION_SPANISH]: {
    type: WorkflowType.ARBITRATION_SPANISH,
    label: "Arbitration (Spanish)",
  },
  [WorkflowType.RFMS]: {
    type: WorkflowType.RFMS,
    label: "RFMS",
  },
};

/** Static labels for known workflow types; facility-specific lists come from WorkflowService. */
